// AI Generated File
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { DEFAULTS } from '@monsido/core/constants/defaults.constant';

@Component({
    selector: 'statistics-date-picker',
    templateUrl: './statistics-date-picker.component.html',
    standalone: false,
})
export class StatisticsDatePickerComponent implements OnInit, OnDestroy {
    @Input() options?: any;
    @Input() date?: any;
    @Input() unRestrictedMax?: boolean;
    @Input() dateRangeGroup?: string;
    @Input() allowToday?: boolean;

    @Output() dateChange = new EventEmitter<any>();
    @Output() onApply = new EventEmitter();

    dateFormat: string = DEFAULTS.DATE_FORMAT;
    private subject: any;
    private subscription?: Subscription;

    constructor (
        private dateRangeService: DateRangeService,
    ) {}

    ngOnInit (): void {
        this.date = moment(this.date);
        this.dateFormat = DEFAULTS.DATE_FORMAT;

        if (this.dateRangeGroup) {
            this.subject = this.dateRangeService.setRangeGroup(this.dateRangeGroup, this.date);
            this.subscription = this.subject.subscribe((newDate: any) => {
                if (newDate && newDate !== this.date) {
                    this.date = newDate;
                }
            });
        }

        this.options = this.options || { maxDate: moment() };
        this.unRestrictedMax = this.unRestrictedMax || false;
        this.allowToday = this.allowToday || false;

        if (this.date.endDate) {
            if (moment(this.date.endDate).isAfter(moment().endOf('day'))) {
                this.date.endDate = moment()
                    .subtract(this.allowToday ? 0 : 1, 'days')
                    .endOf('day');
            }
            this.date.endDate = moment(this.date.endDate);
        } else {
            this.date.endDate = moment()
                .subtract(this.allowToday ? 0 : 1, 'days')
                .endOf('day');
        }

        if (this.date.startDate) {
            this.date.startDate = moment(this.date.startDate);
        } else {
            this.date.startDate = moment().subtract(7, 'days');
        }
    }

    ngOnDestroy (): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    apply (): void {
        if (this.subject) {
            this.subject.next(this.date);
        }
        this.dateChange.emit(this.date);
        this.onApply.emit(this.date);
    }
}
